import React from 'react';
import { Card, CardContent, CardHeader, Box } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor?: string;
    backgroundColor?: string | string[];
    tension?: number;
  }[];
}

interface RevenueChartProps {
  title: string;
  data: ChartData;
  type?: 'line' | 'bar';
  height?: number;
}

const RevenueChart: React.FC<RevenueChartProps> = ({
  title,
  data,
  type = 'line',
  height = 300,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            return '₹' + value.toLocaleString();
          },
        },
      },
    },
  };

  const ChartComponent = type === 'line' ? Line : Bar;

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={title} />
      <CardContent>
        <Box sx={{ height: height }}>
          <ChartComponent data={data} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default RevenueChart;